import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { actions } from '../../actions/paymentActions';
import { actions as loginActions } from '../../../../EntryPage/actions/actions';
import { actions as popUpActions } from '../../../../components/DesktopPopUp/actions/actions';
import { ReactComponent as MCIcon } from '../../../../svgs/mastercard.svg';
import { ReactComponent as VisaIcon } from '../../../../svgs/visa.svg';
import { ReactComponent as CreditCard } from '../../../../svgs/creditcard.svg';
import { ReactComponent as Arrow } from '../../../../svgs/rightarrow2.svg';
import { ReactComponent as Spinner } from '../../../../svgs/spinner.svg';
import { isDesktop } from '../../../../config';
import styles from './form.module.css';
import { getToken } from 'libs/newHttp';

class Form extends Component {
  static propTypes = {
    sendDataToServer: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    error: PropTypes.string,
    loginError: PropTypes.object,
    loginPayload: PropTypes.object,
    success: PropTypes.bool.isRequired,
    stripe: PropTypes.objectOf(PropTypes.func),
    handleNext: PropTypes.func,
    isProcessing: PropTypes.bool,
    onError: PropTypes.func,
    hideSaveCard: PropTypes.bool,
    hideLogin: PropTypes.bool,
    login: PropTypes.func,
  };
  state = {
    submitDisabled: false,
    paymentProcessing: false,
    paymentComplete: false,
    cardNumber: null,
    cardExpiry: null,
    cardCvc: null,
    numberComplete: false,
    expiryComplete: false,
    cvcComplete: false,
    brand: 'unknown',
    name: '',
    focusInput: '',
    saveCard: false,
    loggedIn: false,
    emailError: '',
    passwordError: '',
    loginBlurb: 'Please log in to save your card details for future payments. If you do not have an account, one will be created for you using the booking details.',
    displayBlurb: true,
  };
  componentDidMount() {
    if (this.form && this.props.stripe) {
      this.createElements(this.props.stripe);
    }
  }
  UNSAFE_componentWillReceiveProps({ stripe, error, success, token, loginPayload }) {
    if (stripe && !this.props.stripe) {
      this.createElements(stripe);
    }
    if (error !== this.props.error) {
      this.props.setError(
        'Whoops, we were unable to process this card. Please confirm that your details are correct, or try using a different payment method.',
      );
    }
    if (success && !this.props.success && this.props.handleNext) {
      this.props.handleNext();
    }
    if (loginPayload && loginPayload != this.props.loginPayload) {
      if (loginPayload.isNewlyRegistered) {
        this.setState({ loginBlurb: 'You have successfully registered and logged in.' });
      } else {
        this.setState({ loginBlurb: 'You have successfully logged in.' });
      }

      setTimeout(() => {
        this.setState({ displayBlurb: false });
      }, 2000);
    }

    if (token !== this.props.token) {
      this.setState({ loggedIn: token && token != undefined && token != null && token != '' });
    }
  }
  toggleInputState = (input, isComplete) => {
    this.setState({ [input]: isComplete });
  };
  toggleSaveCard = () => {
    const token = getToken();
    this.setState({ loggedIn: token && token != undefined && token != null && token != '' });
    this.setState({ saveCard: !this.state.saveCard });
  };
  createElements = stripe => {
    const style = {
      base: {
        color: '#585858',
        fontSize: isDesktop() ? '15px' : '16px',
        lineHeight: '38px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#DADADA',
        },
      },
    };
    const elements = stripe.elements();
    const cardNumber = elements.create('cardNumber', {
      hidePostalCode: true,
      placeholder: '0000 0000 0000 0000',
      style,
    });
    const cardExpiry = elements.create('cardExpiry', {
      hidePostalCode: true,
      style,
    });
    const cardCvc = elements.create('cardCvc', {
      hidePostalCode: true,
      placeholder: '000',
      style,
    });
    this.setState({ cardNumber, cardExpiry, cardCvc });
    cardNumber.on('change', e => {
      if (e.brand) this.setState({ brand: e.brand });
      if (e.error && this.props.onError) this.props.onError(e.error.message);
      this.toggleInputState('numberComplete', e.complete);
    });
    cardExpiry.on('change', e => {
      if (e.error && this.props.onError) this.props.onError(e.error.message);
      this.toggleInputState('expiryComplete', e.complete);
    });
    cardCvc.on('change', e => {
      if (e.error && this.props.onError) this.props.onError(e.error.message);
      this.toggleInputState('cvcComplete', e.complete);
    });
    cardNumber.on('focus', this.handleFocus('number'));
    cardExpiry.on('focus', this.handleFocus('expiry'));
    cardCvc.on('focus', this.handleFocus('cvc'));
    cardNumber.mount('#card-number');
    cardExpiry.mount('#card-expiry');
    cardCvc.mount('#card-cvc');
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.props.hideSaveCard) this.setState({ saveCard: true });
    this.setState({ submitDisabled: true, paymentProcessing: true });
    this.props.stripe
      .createToken(this.state.cardNumber, { name: this.state.name })
      .then(res => {
        if (res.error) {
          this.props.onError(res.error.message);
        } else {
          this.setState(
            {
              paymentComplete: true,
              submitDisabled: false,
              paymentProcessing: false,
              // token: res.token,
            },
            this.handleToken(res.token),
          );
        }
      });
  };

  handleLoginOrRegister = e => {
    e.preventDefault();
    if (!this.props.hideLogin) {
      let sessionId = this.props.appointment;
      this.props.login(this.email.value, this.password.value, sessionId);
    }
  };

  handleToken = token => () => {
    this.props.sendDataToServer(token.id, this.props.token, this.props.appointment, this.state.saveCard);
  };
  handleFocus = input => () => {
    this.setState({ focusInput: input });
  };
  handleNameChange = e => {
    this.setState({ name: e.target.value.toUpperCase() });
  };
  handleEmailBlur = e => {
    let email = e.target.value;
    let error = this.validateEmail(email) ? "" : "Please enter a valid email address";
    this.setState({ emailError: error });
  };
  handlePasswordBlur = e => {
    let password = e.target.value;
    let error = this.isValidPasswordText(password);
    this.setState({ passwordError: error });
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  isValidPasswordText = (password) => {
    const text = [
      " be at least 8 characters long",
      " at least 1 lower case character",
      " 1 upper case character",
      " 1 numeric character"
    ]
    let check = 0;
    let ret = "Your password should";
    if (password.length < 8) {
      ret += text[0];
      check += 1;
    }
    if (!/[a-z]/.test(password)) {
      if (check > 0) ret += ", and";
      ret += ` contain ${text[1]}`;
      check += 2;
    }
    if (!/[A-Z]/.test(password)) {
      if (check > 0) ret += ",";
      if (check == 1) ret += " and contain at least";
      ret += ` ${text[2]}`;
      check += 4;
    }
    if (!/\d/.test(password)) {
      if (check > 0) ret += ", and";
      if (check == 1) ret += " contain at least";
      ret += ` ${text[3]}`;
      check += 8;
    }
    if (check == 0) return "";
    return ret;
  }

  render() {
    const { isProcessing } = this.props;
    const { submitDisabled, paymentProcessing, brand, name } = this.state;
    const getCardIcon = () => {
      if (brand === 'mastercard') return <MCIcon className={styles.cardIcon} />;
      if (brand === 'visa') return <VisaIcon className={styles.cardIcon} />;
      return <CreditCard className={styles.cardIcon} />;
    };
    const {
      numberComplete,
      expiryComplete,
      cvcComplete,
      focusInput,
      saveCard,
    } = this.state;
    const valid = numberComplete && expiryComplete && cvcComplete && (this.state.saveCard && this.state.loggedIn || !this.state.saveCard);
    let button;
    if (!this.props.hideSaveCard && this.state.saveCard && !this.state.loggedIn) {
      button = <button className={styles.loginButton} onClick={this.handleLoginOrRegister}>Register / Log In</button>;
    } else {
      button = <button className={styles.loginButton}></button>;
    }
    return (
      <form
        className={styles.container}
        onSubmit={this.handleSubmit}
        id="payment-form"
        ref={c => {
          this.form = c;
        }}
      >
        <div className="form-row">
          <div className={styles.inputContainer}>
            <label
              className={classnames(styles.label, {
                [styles.focused]: focusInput === 'number',
              })}
              htmlFor="card-number"
            >
              Card number
            </label>
            <div id="card-number" className={styles.numberInput} />
            {getCardIcon()}
          </div>
          <div className={styles.inputContainer}>
            <label
              className={classnames(styles.label, {
                [styles.focused]: focusInput === 'name',
              })}
              htmlFor="card-name"
            >
              Name on the card
            </label>
            <input
              id="card-name"
              className={styles.input}
              value={name}
              onChange={this.handleNameChange}
              onFocus={this.handleFocus('name')}
            />
          </div>
          <div className={styles.doubleContainer}>
            <div className={styles.expContainer}>
              <label
                className={classnames(styles.label, {
                  [styles.focused]: focusInput === 'expiry',
                })}
                htmlFor="card-expiry"
              >
                Exp Date
              </label>
              <div id="card-expiry" className={styles.input} />
            </div>
            <div className={styles.cvcContainer}>
              <label
                className={classnames(styles.label, {
                  [styles.focused]: focusInput === 'cvc',
                })}
                htmlFor="card-cvc"
              >
                CVC
              </label>
              <div id="card-cvc" className={styles.input} />
            </div>
          </div>

          {!this.props.hideSaveCard &&
            <div className={styles.inputContainer}>
              <input id="save-card"
                type="checkbox"
                checked={saveCard}
                onChange={this.toggleSaveCard}
              />
              <label
                className={classnames(styles.cardLabel)}
                htmlFor="save-card">
                Save my card to make
                <br />
                future payments faster
              </label>
            </div>
          }

          {!this.props.hideSaveCard && this.state.saveCard && (this.state.displayBlurb || !this.state.loggedIn) &&
            <div className={styles.loginBlurb}>
              <span className={styles.loginBlurbText}>{this.state.loginBlurb}</span>
            </div>
          }

          {!this.props.hideSaveCard && this.state.saveCard && !this.state.loggedIn &&
            <div className={styles.innerContainer}>
              <span className={styles.label}>Email</span>
              <div className={styles.inputContainer} style={{ margin: '0px' }}>
                <input
                  className={styles.input}
                  type="email"
                  ref={c => {
                    this.email = c;
                  }}
                  placeholder={null}
                  onBlur={this.handleEmailBlur}
                />
              </div>
              {this.state.emailError && this.state.emailError != '' && <span className={styles.error}>{this.state.emailError}</span>}
              <div style={{ marginBottom: '15px' }} />
              <span className={styles.label}>Password</span>
              <div className={styles.inputContainer} style={{ margin: '0px' }}>
                <input
                  className={styles.input}
                  type="password"
                  ref={c => {
                    this.password = c;
                  }}
                  placeholder={null}
                  onBlur={this.handlePasswordBlur}
                />
              </div>
              {this.state.passwordError && this.state.passwordError != '' && <span className={styles.error}>{this.state.passwordError}</span>}
              <div style={{ marginBottom: '15px' }} />
            </div>
          }
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {button}
          <button
            disabled={submitDisabled || !valid}
            type="submit"
            className={classnames(styles.submit, {
              [styles.activeButton]: valid,
            })}
          >
            {paymentProcessing || isProcessing ? (
              <Spinner className={styles.spinner} />
            ) : (
              <Arrow className={styles.arrow} />
            )}
          </button></div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  token: state.loginReducer.token,
  loginError: state.loginReducer.error,
  loginPayload: state.loginReducer.payload,
  error: state.paymentFormReducer.error,
  success: state.paymentFormReducer.success,
  isProcessing: state.paymentFormReducer.isProcessing,
});
const mapDispatchToProps = dispatch => ({
  sendDataToServer: bindActionCreators(actions.sendPaymentInfo, dispatch),
  setError: bindActionCreators(popUpActions.setError, dispatch),
  login: bindActionCreators(loginActions.loginOrRegister, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form);
